<template>
  <div class="view-wrapper">

    <div class="search-container elevation-1 white px-3 pt-2 pb-2 d-flex flex-column">
      
      <v-radio-group 
        v-model="tipoBusca" 
        row 
        hide-details 
        class="mt-0 mb-3" 
        @change="focarInputBusca"
      >
        <v-radio label="Placa" value="placa" color="primary"></v-radio>
        <v-radio label="Descrição" value="descricao" color="primary"></v-radio>
        <v-radio label="Código" value="codigo" color="primary"></v-radio>
      </v-radio-group>

      <div class="d-flex align-center" style="width: 100%;">
        <v-text-field
          ref="campoBusca"
          v-model="termoBusca"
          :label="labelBusca"
          outlined
          dense
          clearable
          hide-details
          class="mr-2"
          @keydown.enter="forcarBusca('qualquer')"
        ></v-text-field>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2 mr-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('inicio')"
          title="Buscar pelo Início"
        >
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('qualquer')"
          title="Buscar em Qualquer Parte"
        >
          <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="content-container elevation-2">
      <div v-if="loading" class="text-center pa-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p class="mt-4 mb-0">{{ textoLoading }}</p>
      </div>

      <div v-else-if="!loading && resultados.length === 0" class="text-center pa-8">
        <p class="mb-0">Nenhum veículo encontrado.</p>
      </div>

      <RecycleScroller
        v-else
        ref="scrollerComponent" 
        class="scroller" 
        :items="resultados"
        :item-size="105" 
        :buffer="1000" 
        key-field="idveiculo"
        v-slot="{ item }"
      >
        <v-list-item
          class="list resultado-item-clicavel px-2"
          :class="{ 'item-selecionado': itemSelecionado === item }"
          style="height: 105px; border-bottom: 1px solid #e0e0e0;"
          @click="selecionarEVoltar(item)"
        >
          <v-list-item-content>
            <v-list-item-title 
              class="dado-destacado3 font-weight-medium text-wrap text-justify" 
              style="height: auto; max-height: 48px; overflow: hidden; line-height: 1.2rem;"
            >
              <span v-if="item.placa" class="font-weight-bold primary--text mr-2">{{ item.placa }}</span>
              <span>- {{ item.descricao || 'Veículo sem descrição' }}</span>
            </v-list-item-title>
            
            <v-list-item-subtitle class="dado-destacado4 mt-1">
              <span v-if="item.marca" class="mr-3">Marca: <span class="font-weight-medium">{{ item.marca }}</span></span>
              <span v-if="item.codigo">Cód: <span class="font-weight-medium">{{ item.codigo }}</span></span>
            </v-list-item-subtitle>

            <v-list-item-subtitle class="mt-1 d-flex align-center flex-wrap"> 
              <span v-if="item.cor" class="dado-destacado2 grey--text text--darken-1 mr-3">
                Cor: {{ item.cor }}
              </span>

              <span v-if="item.ano || item.anoModelo" class="dado-destacado2 grey--text text--darken-1 mr-3">
                Ano: {{ item.ano }}{{ item.anoModelo ? '/' + item.anoModelo : '' }}
              </span>

              <span v-if="item.combustivel" class="dado-destacado2 grey--text text--darken-1 mr-3">
                Combustível: {{ formatarCombustivel(item.combustivel) }}
              </span>

              <span v-if="item.chassi" class="dado-destacado2 grey--text text--darken-1">
                Chassi: {{ item.chassi }}
              </span>
            </v-list-item-subtitle>

          </v-list-item-content>

        </v-list-item>
      </RecycleScroller>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import db from '@/plugins/dexie';

Vue.use(VueVirtualScroller)

export default {
  name: 'ViewVeiculoIndex',
  
  data() {
    return {
      idCliente: this.$route.query.idcliente || null,
      
      termoBusca: this.$route.query.busca || '',
      tipoBusca: this.$route.query.tipoBusca || 'placa', 
      modoBusca: this.$route.query.modoBusca || 'qualquer',

      loading: false, 
      loadingInicial: true, 
      textoLoading: 'Carregando veículos locais...',
      itemSelecionado: null,
      resultados: [], 
      previousRouteName: null,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.$refs.scrollerComponent && this.$refs.scrollerComponent.$el) {
      const scrollPos = this.$refs.scrollerComponent.$el.scrollTop;
      sessionStorage.setItem('listaVeiculosScrollPos', scrollPos);
    }
    next();
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(novoQuery, antigoQuery) {
        if (novoQuery.idcliente) this.idCliente = novoQuery.idcliente;
        
        if (novoQuery.busca !== this.termoBusca) {
          this.termoBusca = novoQuery.busca || '';
        }

        if (!antigoQuery) {
          this.iniciarProcesso();
          return;
        }
        
        const mudouBusca = novoQuery.busca !== antigoQuery.busca;
        const mudouTipo = novoQuery.tipoBusca !== antigoQuery.tipoBusca;
        const mudouModo = novoQuery.modoBusca !== antigoQuery.modoBusca;
        
        if (mudouBusca || mudouTipo || mudouModo) {
          this.iniciarProcesso();
        } 
        else if (novoQuery.selecionadoId !== antigoQuery.selecionadoId) {
          this.restaurarSelecaoDaUrl();
        }
      },
    },
  },

  computed: {
    labelBusca() {
      if (this.tipoBusca === 'placa') return 'Buscar por Placa';
      if (this.tipoBusca === 'codigo') return 'Buscar por Código';
      return 'Buscar por Descrição / Modelo';
    }
  },

  methods: {
    focarInputBusca() {
      this.$nextTick(() => {
        if (this.$refs.campoBusca) {
          this.$refs.campoBusca.focus();
          const nativeInput = this.$refs.campoBusca.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.select();
          }
        }
      });
    },

    removerAcentos(texto) {
      if (!texto) return '';
      return texto.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    },

    forcarBusca(modoSelecionado = null) {
      if (modoSelecionado) {
        this.modoBusca = modoSelecionado;
      }
      
      const query = { ...this.$route.query };
      const buscaLimpa = this.termoBusca ? this.termoBusca.trim() : '';

      if (buscaLimpa !== '') {
        query.busca = buscaLimpa;
        query.modoBusca = this.modoBusca;
      } else {
        delete query.busca;
        delete query.modoBusca;
      }

      query.tipoBusca = this.tipoBusca;

      if (this.$route.query.busca !== query.busca || 
          this.$route.query.tipoBusca !== query.tipoBusca ||
          this.$route.query.modoBusca !== query.modoBusca) {
        this.$router.replace({ query }).catch(() => {});
      } else {
        this.iniciarProcesso();
      }
    },

    async iniciarProcesso() {
      this.itemSelecionado = null;
      this.loading = true;
      this.loadingInicial = true; 

      await this.carregarPaginaVisualizacao();
      
      this.loadingInicial = false; 
      this.loading = false;

      this.restaurarPosicaoScroll();
    },

    restaurarPosicaoScroll() {
      const posSalva = sessionStorage.getItem('listaVeiculosScrollPos');
      
      if (posSalva && this.resultados.length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            const scroller = this.$refs.scrollerComponent;
            if (scroller && scroller.$el) {
              scroller.$el.scrollTop = parseInt(posSalva);
            }
          }, 100);
        });
      }
    },

    async carregarPaginaVisualizacao() {
      try {
        const { busca, tipoBusca, modoBusca, idcliente } = this.$route.query;
        const filtroClienteId = idcliente ? String(idcliente) : null;
        
        const filtroBusca = busca ? busca.toLowerCase().trim() : null;
        const tipoBuscaAtivo = tipoBusca || 'placa';
        const modoBuscaAtivo = modoBusca || 'qualquer';

        let veiculos = await db.veiculo.toArray();

        if (filtroClienteId) {
          veiculos = veiculos.filter(v => String(v.veiidcliente) === filtroClienteId);
        }

        if (filtroBusca) {
          veiculos = veiculos.filter(v => {
            let match = true;
            const termoBuscaAcento = this.removerAcentos(filtroBusca);

            if (tipoBuscaAtivo === 'placa') {
              const placa = (v.veiplaca || v.placa || '').toString().replace(/[^a-zA-Z0-9]/g, '');
              const buscaLimpaPlaca = filtroBusca.replace(/[^a-zA-Z0-9]/g, '');
              if (modoBuscaAtivo === 'inicio') {
                if (!placa.toLowerCase().startsWith(buscaLimpaPlaca)) match = false;
              } else {
                if (!placa.toLowerCase().includes(buscaLimpaPlaca)) match = false;
              }
            }
            else if (tipoBuscaAtivo === 'descricao') {
              const desc = v.veidescricao || v.descricao || '';
              const descLimpa = this.removerAcentos(desc.toLowerCase());
              
              if (modoBuscaAtivo === 'inicio') {
                if (!descLimpa.startsWith(termoBuscaAcento)) match = false;
              } else {
                if (!descLimpa.includes(termoBuscaAcento)) match = false;
              }
            } 
            else if (tipoBuscaAtivo === 'codigo') {
              const cod = (v.veiidveiculo).toString();
              if (modoBuscaAtivo === 'inicio') {
                if (!cod.startsWith(filtroBusca)) match = false;
              } else {
                if (!cod.includes(filtroBusca)) match = false;
              }
            }
            return match;
          });
        }
        
        this.resultados = veiculos.map(v => this.mapearVeiculoParaView(v));
        this.restaurarSelecaoDaUrl();
        
        return true;

      } catch (e) {
        console.error("Erro ao carregar veículos do Dexie:", e);
        return false;
      }
    },

    formatarCombustivel(val) {
      if (!val) return '';
      const map = { D: 'Diesel', E: 'Etanol', F: 'Flex', G: 'Gasolina' };
      const s = String(val).trim().toUpperCase();
      return map[s] || val;
    },

    mapearVeiculoParaView(v) {
      return {
        dexieId: v.id,
        idveiculo: v.veiidveiculo || v.id,
        codigo: v.veiidveiculo || v.id,
        descricao: v.veidescricao || v.descricao || '',
        placa: v.veiplaca || v.placa || '',
        cor: v.veicor,
        idCor: v.veiidcor,
        marca: v.veimarcanome,
        idMarca: v.veiidmarca,
        frota: v.veifrota,
        combustivel: v.veicombustivel || v.combustivel || '',
        ano: v.veiano || v.ano || '',
        anoModelo: v.veianomodelo || v.anoModelo || '',
        idCliente: v.veiidcliente || '',
        chassi: v.veichassi || v.chassi || '',
        numSerie: v.veinumeroserie || v.veinumserie || v.numSerie || '',
        status: v.veistatus,
        idCidade: v.veiidcidade,
        dataAlteracao: v.veidataalteracao,
      };
    },

    selecionarEVoltar(item) {
      if (!item) return;
      const dadosVeiculo = {
        dexieId: item.dexieId,
        idveiculo: item.idveiculo,
        codigo: item.codigo,
        descricao: item.descricao,
        placa: item.placa,
        marca: item.marca,
        veimarcanome: item.marca,
        cor: item.cor,
        veicor: item.cor,
        frota: item.frota,
        veifrota: item.frota,
        combustivel: item.combustivel,
        veicombustivel: item.combustivel,
        ano: item.ano,
        veiano: item.ano,
        modelo: item.anoModelo || item.modelo,
        veianomodelo: item.anoModelo || item.modelo,
        chassi: item.chassi,
        veichassi: item.chassi,
        numSerie: item.numSerie,
        veinumeroserie: item.numSerie,
        idCliente: item.idCliente
      };
      const dadosParaCadastro = {
        ...dadosVeiculo,
        tipo: 'Veiculo',
        codigo: item.placa || item.codigo,
        id: item.idveiculo,
        dexieId: item.dexieId,
        nome: item.descricao
      };
      sessionStorage.setItem('pesquisaResultado', JSON.stringify(dadosParaCadastro));
      sessionStorage.setItem('veiculo_selecionado_retorno', JSON.stringify(dadosVeiculo));
      this.$router.back();
    },

    restaurarSelecaoDaUrl() {
      const { selecionadoId } = this.$route.query;
      if (selecionadoId && this.resultados.length > 0) {
        const idParaSelecionar = parseInt(selecionadoId);
        const itemEncontrado = this.resultados.find(p => p.idveiculo === idParaSelecionar);
        if (itemEncontrado) this.itemSelecionado = itemEncontrado;
      }
    },
  },

  mounted() {
    this.focarInputBusca();
  }
};
</script>

<style scoped>
.view-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
}
.content-container {
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}
.scroller {
  height: 100%;
  overflow-y: auto;
}
.scroller::-webkit-scrollbar {
  width: 12px;
}
.scroller::-webkit-scrollbar-thumb {
  background: rgba(76, 111, 175, 0.4);
  border-radius: 4px;
}
.scroller::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}

.item-selecionado {
  background-color: #E3F2FD !important;
}
.dado-destacado2 {
  font-size: 0.80rem;
}
.dado-destacado4 {
  font-size: 0.85rem;
  color: #616161;
}
.dado-destacado3 {
  font-size: 1rem;
}
.list {
  background-color: white;
}

::v-deep .v-input--radio-group__input {
  display: flex;
  width: 100%;
}
::v-deep .v-radio {
  margin-right: 16px !important;
}
</style>